import { Alert, Box, Button, Card, CardContent, Fab, Grid, Paper, Snackbar, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import UE from '../Objetos/UE';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function CopiarLink(props) {

    const link = UE.getLink(props.tipo, props.id);


    //Snackbar
    const [open, setOpen] = React.useState(false)
    const copiarTexto = (texto) => {
        setOpen(true)
        navigator.clipboard.writeText(texto)
    }

    return (

        <Box >
            <TextField
                id="outlined-multiline-flexible"
                label="Enlace"
                multiline
                rowsMax={10}
                defaultValue={link}
                margin="normal"
                InputProps={{
                    readOnly: true,
                }}
                fullWidth // Agrega esta propiedad
            />
            <Snackbar
                open={open}
                onClose={() => setOpen(false)}
                autoHideDuration={2000}
                message="Link copiado en el portapapeles"
            />
            <Fab color="primary" variant="extended" onClick={() => { copiarTexto(link) }}>
                <ContentCopyIcon />
                Copiar Enlace
            </Fab>
        </Box>
    )
}
